import {observer} from "mobx-react";
import React from "react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {Box, Button, Container} from "@mui/material";
import {ICookieBannerController} from "views/components/CookieBanner/cookie_banner.controller";
import styled from "@emotion/styled";
import {ReactComponent as CloseIcon} from "assets/img/icon/close.svg";
import {getOpenState} from "data/utils/helper";

const BannerWrapper = styled(Box)`
	position: fixed;
	width: 100%;
	max-width: 700px;
	padding: 20px 0;
	box-sizing: border-box;
	background: #fff;
	transition: all ease 0.5s;
	box-shadow: 0 0 18px rgb(0 0 0 / 20%);
	bottom: 0;
	left: 0;
	z-index: 999;

	&.open {
		transform: translateY(0);
	}

	&.closed {
		transform: translateY(200%);
	}
`;
const Description = styled(Box)`
	font-style: normal;
	font-size: 13px;
	line-height: 118%;
	letter-spacing: 0.06em;
	color: #696969;

	a {
		color: #c81414;
		text-decoration: underline;
	}
`;
const CloseButton = styled(Button)`
	position: absolute;
	right: 6px;
	top: 6px;
	min-width: unset;
`;

export const CookieBanner: React.FC = observer(() => {
	const {isViewed, closeBanner} = useViewController<ICookieBannerController>(
		Bindings.CookieBannerController
	);

	return !isViewed ? (
		<BannerWrapper className={getOpenState(!isViewed)}>
			<Container>
				<CloseButton onClick={closeBanner}>
					<CloseIcon />
				</CloseButton>
				<Description>
					This website uses cookies and other tracking technologies to enhance user
					experience and to analyze performance and traffic on our website. We also share
					information about your use of our site with our social media, advertising and
					analytics partners. If we have detected an opt-out preference signal then it
					will be honored. Further information is available in our{" "}
					<a
						onClick={closeBanner}
						href={"https://www.rydercup.com/privacy-policy"}
						target={"_blank"}
						rel="noreferrer">
						Click here for our Cookie and Privacy Policy.
					</a>
				</Description>
			</Container>
		</BannerWrapper>
	) : null;
});
